var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-phisical-tco-container"},[_c('WelcomeMessage',{attrs:{"textPath":'tco.becomeTco.welcomePagePhisical.welcomeBanner'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }